import { render } from "./LimitedCompanyIcon.vue?vue&type=template&id=5983e986"
import script from "./LimitedCompanyIcon.vue?vue&type=script&lang=js"
export * from "./LimitedCompanyIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__